import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import './CustomerReport.css';
import API_URLS from '../summaryapi/apiUrls';
import { CSVLink } from 'react-csv'; // For CSV download
import { RingLoader } from 'react-spinners';
import { FiSearch } from 'react-icons/fi'; // Search icon
import { FaFilePdf, FaFileExcel } from 'react-icons/fa'; // Importing icons
const CustomerReport = () => {
    const [customers, setCustomers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(1);
    const [customersPerPage] = useState(10); // Number of customers per page set to 10
    const [isHovered, setIsHovered] = useState(false);
    useEffect(() => {
        const fetchCustomers = async () => {
            try {
                // Retrieve provider_id or admin_id from sessionStorage
                const encodedProviderId = sessionStorage.getItem('provider_id');
                const encodedAdminId = sessionStorage.getItem('admin_id');

                // Determine which API URL to use based on provider_id or admin_id
                const isProvider = encodedProviderId ? true : false;
                const isAdmin = encodedAdminId ? true : false;

                if (!isProvider && !isAdmin) {
                    toast.error('No valid user session found.');
                    return;
                }

                // Construct API call based on the presence of provider_id or admin_id
                const apiUrl = isProvider
                    ? API_URLS.providerbasedUsers.url // Provider API URL
                    : API_URLS.getCustomerReport.url; // Admin API URL

                const options = isProvider
                    ? {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ provider_id: atob(encodedProviderId) }) // Send provider_id in the body
                    }
                    : {}; // Admin doesn't require a body

                // Make the API call
                const response = await fetch(apiUrl, options);
                if (!response.ok) {
                    throw new Error('Failed to fetch customer data');
                }

                const result = await response.json();

                if (result.status) {
                    setCustomers(result.data); // Assuming result.data contains the customer array
                } else {
                    toast.error('Error: ' + result.message);
                }
            } catch (error) {
                console.error('Error:', error);
                toast.error('An error occurred while fetching customer data.');
            } finally {
                setLoading(false);
            }
        };

        fetchCustomers();
    }, []);

    if (loading) {
        return (
            <div className="loading-spinner" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <h4>Please Wait.....</h4>
                <RingLoader color="#3498db" loading={loading} size={50} />
            </div>
        );
    }

    // Sorting customers by created_at in descending order
    const sortedCustomers = [...customers].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

    // Filtering customers based on the search query
    const filteredCustomers = sortedCustomers.filter((customer) =>
        customer.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        (customer.email && customer.email.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (customer.MobileNo && customer.MobileNo.includes(searchQuery))
    );

    // Pagination logic
    const indexOfLastCustomer = page * customersPerPage;
    const indexOfFirstCustomer = indexOfLastCustomer - customersPerPage;
    const currentCustomers = filteredCustomers.slice(indexOfFirstCustomer, indexOfLastCustomer);

    // Change page number
    const paginate = (pageNumber) => setPage(pageNumber);

    const columns = [
        { label: 'Name', key: 'name' },
        { label: 'Email', key: 'email' },
        { label: 'Mobile No', key: 'MobileNo' },
        { label: 'Address', key: 'address' },
        { label: 'Created At', key: 'created_at' } // Included Created At
    ];

    return (
        <div className="customer-report-page" style={{ padding: '20px' }}>
            <h3 className="customer-report-heading" style={{color: '#8A2BE2'}}>Customer Report</h3>

            <div className="header-actions" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <div className="search-bar">
                    <input
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}  
                        style={{
                            padding: '8px',
                            borderRadius: '4px',
                            border: isHovered ? '3px solid lightblue' : '1px solid lightblue', 
                            minWidth: '200px',
                            marginRight: '8px',
                            outline: 'none', 
                            transition: 'border 0.3s ease', 
                            marginTop:'20px'
                          }}
                    />
                         <FiSearch style={{ fontSize: '20px', color: '#888' }} /> 
                </div>

                <div className="download-buttons" style={{ display: 'flex', alignItems: 'center' }}>
                <button className="download-print" onClick={() => window.print()}          style={{
                    width:'150px',
                    backgroundColor: 'red',
                    height:'40px',
                    color: 'white',
                    textAlign: 'center',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                }}>
                       <span style={{ fontSize: '15px' }}> Download </span> <FaFilePdf style={{ fontSize: '15px' }} /> 
                    </button>
                    <CSVLink data={filteredCustomers} filename="customer-report.csv">
                        <button className="download-csv"             style={{
                    width:'150px',
                    backgroundColor: 'green',
                    height:'40px',
                    color: 'white',
                    textAlign: 'center',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                }}>
      Download   <FaFileExcel style={{ fontSize: '15px' }} /> {/* Excel Icon */}
                        </button>
                    </CSVLink>
                  
                </div>
            </div>

            {filteredCustomers.length === 0 ? (
                <div className="no-customers-message" style={{color: '#8A2BE2'}}>No customers found.</div>
            ) : (
                <div className="customer-table-container">
                    <table className="customer-report-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead style={{ backgroundColor: 'violet', textAlign: 'center' }}>
  <tr>
    {columns.map((column) => (
      <th
        key={column.key}
        style={{
          padding: '8px',
          textAlign: 'center',
          backgroundColor:'blueviolet'  // Center text within the header cell
        }}
      >
        {column.label}
      </th>
    ))}
  </tr>
</thead>

                        <tbody>
                            {currentCustomers.map((customer) => (
                                <tr key={customer.user_id}>
                                    {columns.map((column) => (
                                        <td key={column.key} style={{ padding: '8px' ,   textAlign: 'center'}}>
                                            {customer[column.key]}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="footer-actions" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '20px' }}>
   <strong><span style={{ fontSize: '16px', color: '#666' }}>
        Total Customers: {filteredCustomers.length}
    </span></strong> 
    <span style={{ marginBottom: '10px' }}>{`Page ${page} of ${Math.ceil(filteredCustomers.length / customersPerPage)}`}</span>
    <div className="pagination" style={{ display: 'flex', alignItems: 'center' }}>
        {/* Disable "First" button if on the first page */}
        <button 
            onClick={() => paginate(1)} 
            style={{ 
                padding: '5px 10px', 
                backgroundColor: 'green', 
                color: 'white', 
                border: 'none', 
                marginRight: '5px',
                cursor: page === 1 ? 'not-allowed' : 'pointer', 
                opacity: page === 1 ? 0.5 : 1 // Make button visually disabled when disabled
            }} 
            disabled={page === 1}
        >
            First
        </button>

        {/* Disable "Previous" button if on the first page */}
        <button 
            onClick={() => paginate(page - 1)} 
            style={{ 
                padding: '5px 10px', 
                backgroundColor: '#e74c3c', 
                color: 'white', 
                border: 'none', 
                marginRight: '5px',
                cursor: page === 1 ? 'not-allowed' : 'pointer',
                opacity: page === 1 ? 0.5 : 1 // Make button visually disabled when disabled
            }} 
            disabled={page === 1}
        >
            &lt; Previous
        </button>

        {/* Enable/Disable "Next" button based on page count */}
        <button 
            onClick={() => paginate(page + 1)} 
            style={{ 
                padding: '5px 10px', 
                backgroundColor: '#3498db', 
                color: 'white', 
                border: 'none', 
                marginLeft: '5px',
                cursor: page === Math.ceil(filteredCustomers.length / customersPerPage) ? 'not-allowed' : 'pointer',
                opacity: page === Math.ceil(filteredCustomers.length / customersPerPage) ? 0.5 : 1 // Make button visually disabled when disabled
            }}
            disabled={page === Math.ceil(filteredCustomers.length / customersPerPage)}
        >
            Next &gt;
        </button>

        {/* Disable "Last" button if on the last page */}
        <button 
            onClick={() => paginate(Math.ceil(filteredCustomers.length / customersPerPage))} 
            style={{ 
                padding: '5px 10px', 
                backgroundColor: '#f39c12', 
                color: 'white', 
                border: 'none', 
                marginLeft: '5px',
                cursor: page === Math.ceil(filteredCustomers.length / customersPerPage) ? 'not-allowed' : 'pointer',
                opacity: page === Math.ceil(filteredCustomers.length / customersPerPage) ? 0.5 : 1 // Make button visually disabled when disabled
            }} 
            disabled={page === Math.ceil(filteredCustomers.length / customersPerPage)}
        >
            Last
        </button>
    </div>
</div>



                </div>
            )}
        </div>
    );
};

export default CustomerReport;
